import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}
const SwitchIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SwitchGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.7197 22C7.20557 22 2.71973 17.5137 2.71973 12C2.71973 6.48633 7.20557 2 12.7197 2C18.2339 2 22.7197 6.48633 22.7197 12C22.7197 17.5137 18.2339 22 12.7197 22ZM12.7197 3C7.75733 3 3.71973 7.03711 3.71973 12C3.71973 16.9629 7.75733 21 12.7197 21C17.6821 21 21.7197 16.9629 21.7197 12C21.7197 7.03711 17.6821 3 12.7197 3Z"
        fill="#696969"
      />
      <path
        d="M15.1934 16.1895C14.917 16.1895 14.6934 15.9658 14.6934 15.6895V8.04786C14.6934 7.77149 14.917 7.54786 15.1934 7.54786C15.4697 7.54786 15.6934 7.77149 15.6934 8.04786V15.6895C15.6934 15.9658 15.4697 16.1895 15.1934 16.1895Z"
        fill="#696969"
      />
      <path
        d="M17.2588 10.4316C17.1382 10.4316 17.0176 10.3887 16.9219 10.3008L15.1934 8.72461L13.4634 10.3008C13.2588 10.4883 12.9434 10.4727 12.7568 10.2685C12.5708 10.0645 12.5854 9.74804 12.7895 9.5625L14.8564 7.67871C15.0478 7.50488 15.3398 7.50488 15.5303 7.67871L17.5957 9.5625C17.7998 9.74805 17.8144 10.0645 17.6284 10.2685C17.5298 10.377 17.3945 10.4316 17.2588 10.4316Z"
        fill="#696969"
      />
      <path
        d="M10.2461 16.1895C9.96973 16.1895 9.7461 15.9658 9.7461 15.6895V8.04786C9.7461 7.77149 9.96973 7.54786 10.2461 7.54786C10.5225 7.54786 10.7461 7.77149 10.7461 8.04786V15.6895C10.7461 15.9658 10.5225 16.1895 10.2461 16.1895Z"
        fill="#696969"
      />
      <path
        d="M10.2461 16.1895C10.1255 16.1895 10.0044 16.1455 9.90919 16.0586L7.84376 14.1748C7.63966 13.9893 7.62501 13.6729 7.81105 13.4688C7.9966 13.2637 8.31398 13.25 8.51759 13.4365L10.2461 15.0127L11.9756 13.4365C12.1797 13.251 12.4961 13.2647 12.6821 13.4688C12.8682 13.6729 12.8535 13.9893 12.6494 14.1748L10.583 16.0586C10.4873 16.1455 10.3667 16.1895 10.2461 16.1895Z"
        fill="#696969"
      />
    </svg>
  );
};

export default SwitchIcon;
